import AbstractCallerIds from '@Containers/UserCallerIds/AbstractCallerIds';
import { VoiceProvider } from '@Models/callerIds.models';

const TelnyxCallerIds = (): JSX.Element => (
  <AbstractCallerIds provider={VoiceProvider.TELNYX} />
);

export default TelnyxCallerIds;
